import html from '../assets/Skills/stack/HTML.png';
import css from '../assets/Skills/stack/CSS.png';
import js from '../assets/Skills/stack/Javascript.svg';
import java from '../assets/Skills/java.png';
import tailwind from '../assets/Skills/stack/Tailwind.png';
import react from '../assets/Skills/stack/React.png';
import express from '../assets/Skills/stack/Express.png';
import node from '../assets/Skills/stack/NodeJs.svg';
import mysql from '../assets/Skills/mysql.png';
import mongodb from '../assets/Skills/stack/MongoDB.svg';
import git from '../assets/Skills/stack/Git.svg';
import github from '../assets/Skills/stack/Github.svg';
import githubLight from '../assets/Skills/github-white.png';
import next from '../assets/Skills/nextjs.png';
import ts from '../assets/Skills/typescript.png';
import postgresql from '../assets/Skills/postgresql.png';
import postgresqlDark from '../assets/Skills/postgresqlDark.png';
import aws from '../assets/Skills/aws.png';
import restapiLight from '../assets/Skills/restapi-light.png';
import restapiDark from '../assets/Skills/restapi-dark.png';

const skills = [
    {
        sourceLight: html,
        sourceDark: html,
        text: "HTML"
    },
    {
        sourceLight: css,
        sourceDark: css,
        text: "CSS"
    },
    {
        sourceLight: js,
        sourceDark: js,
        text: "JavaScript"
    },
    {
        sourceLight: ts,
        sourceDark: ts,
        text: "TypeScript"
    },
    {
        sourceLight: java,
        sourceDark: java,
        text: "Java"
    },
    {
        sourceLight: react,
        sourceDark: react,
        text: "React.js"
    },
    {
        sourceLight: next,
        sourceDark: next,
        text: "Next.js"
    },
    {
        sourceLight: express,
        sourceDark: express,
        text: "Express.js"
    },
    {
        sourceLight: node,
        sourceDark: node,
        text: "Node.js"
    },
    {
        sourceLight: aws,
        sourceDark: aws,
        text: "Amazon Web Services"
    },
    {
        sourceLight: restapiLight,
        sourceDark: restapiDark,
        text: "REST APIs"
    },
    {
        sourceLight: mongodb,
        sourceDark: mongodb,
        text: "MongoDB"
    },
    {
        sourceLight: postgresql,
        sourceDark: postgresqlDark,
        text: "PostgreSQL"
    },
    {
        sourceLight: mysql,
        sourceDark: mysql,
        text: "MySQL"
    },
    {
        sourceLight: tailwind,
        sourceDark: tailwind,
        text: "Tailwind CSS"
    },
    {
        sourceLight: git,
        sourceDark: git,
        text: "Git"
    },
    {
        sourceLight: github,
        sourceDark: githubLight,
        text: "GitHub"
    }
]; 

export default skills;